import { Overlay } from 'trading-vue-js';

export default {
    name: 'ALMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad',
                version: '1.0.0',
                desc: 'Arnaud Legoux Moving Average',
                preset: {
                    name: 'ALMA $length $offset $sigma',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#559de0',
                    },
                },
            };
        },
        use_for() {
            return ['ALMA'];
        },
        calc() {
            return {
                props: {
                    length: { def: 10, text: 'Length' },
                    offset: { def: 0.9, text: 'Offset' },
                    sigma: { def: 5, text: 'Sigma' },
                    applyto: { def: `close`, text: 'Apply to' },
                },
                conf: { renderer: 'Spline' },
                update: `
                    let time_series;
                    if(applyto === 'open'){
                        time_series = ts(open[0])
                    }else if(applyto === 'high'){
                        time_series = ts(high[0])                        
                    }else if(applyto === 'low'){
                        time_series = ts(low[0])
                    }else if(applyto === 'hl2'){
                        time_series = ts((high[0] + low[0]) / 2)
                    }else{
                        time_series = ts(close[0])
                    }
                    return alma(time_series, length, offset, sigma)[0]
                `,
            };
        },
    },
};
